import { render, staticRenderFns } from "./ComponentPhone.vue?vue&type=template&id=47e5570c&scoped=true"
import script from "./ComponentPhone.vue?vue&type=script&lang=js"
export * from "./ComponentPhone.vue?vue&type=script&lang=js"
import style0 from "./ComponentPhone.vue?vue&type=style&index=0&id=47e5570c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e5570c",
  null
  
)

export default component.exports